var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/maps-and-flags.a97868b9.png","uri@2x": __webpack_public_path__ + "static/media/maps-and-flags.e92fd9db.png","uri@3x": __webpack_public_path__ + "static/media/maps-and-flags.87bf150a.png",
    width: 9,
    height: 12
});